module.exports = __webpack_public_path__ + "static/img/cont43_05.818a4b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont43_05.jpg
// module id = zDZY
// module chunks = 0